<div
    *ngIf="isLoading"
    style=" position: fixed; top: 0; left: 0; width: 100%;height: 100%; background-color: rgba(0, 0, 0, 0.4);display: flex; align-items: center; justify-content: center; z-index: 9999;">
    <p-progressSpinner
        styleClass="w-4rem h-4rem"
        strokeWidth="4"
        animationDuration=".5s"/>
</div>
